<template>
  <div></div>
</template>
<script>
export default {
  props: {
    selectionsData: {
      type: Array,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    indirectTransform: {
      type: Object,
      required: true
    },
    updateContainerBounds: {
      type: Function,
      required: true
    },
    holder: {
      type: Object,
      required: true
    },
    indirectlySelected: {
      type: Boolean,
      required: false
    },
    parentTransform: {
      type: Object,
      required: true
    },
    // When you are a child
    childComponent: {
      type: Object,
      required: false
    },
    // For your children
    childrenComponent: {
      type: Object,
      required: false
    }
  },
  mounted() {
    const key = this.makeKey();
    const {transform,indirectlySelected,holder,updateContainerBounds,parentTransform,childComponent,childrenComponent} = this;
    this.data = {
      holder,
      indirectlySelected,
      transform,
      updateContainerBounds,
      parentTransform,
      childComponent,
      childrenComponent,
      key
    }
    this.selectionsData.push(this.data);
  },
  beforeDestroy() {
    const key = this.makeKey();
    const pos = this.selectionsData.findIndex( (d) => {
      return d.key === key;
    });
    this.selectionsData.splice(pos, 1);
  },
  methods:{
    makeKey() {
      return this.transform.id + '-' + this.indirectTransform.id;
    }
  },
  watch:{
    indirectlySelected(nv) {
      this.data.indirectlySelected = nv;
    },
    transform(nv) {
      this.data.transform = nv;
    },
    indirectTransform(nv) {
      this.data.indirectTransform = nv;
    },
    holder(nv) {
      this.data.holder = nv;
    },
    updateContainerBounds(nv) {
      this.data.updateContainerBounds = nv;
    }
  }
}
</script>
